import { useDevice } from "@/contexts/DeviceContext";
import Typewriter from "typewriter-effect";

export default function CustomTypewriterEffect({
  strings,
  emojis,
  typeSpeed,
  pauseDelay,
  overallIterations,
}) {
  const { isMobile } = useDevice();
  return (
    <Typewriter
      onInit={(tw) => {
        tw.changeDelay(typeSpeed);
        tw.changeDeleteSpeed(typeSpeed);
        // We want to revert to the first item after the last item, so we end with i=0
        for (let i = 0; i <= strings.length * overallIterations; i++) {
          const index = i % strings.length;

          // Restart
          tw.deleteAll();
          tw.typeString(strings[index]);
          if (!isMobile) {
            tw.typeString(" ");
          }
          // We need to paste emojis instead of typing them out because they are not supported by the typewriter effect
          if (emojis[index]) {
            tw.pasteString(emojis[index]);
          }
          tw.pauseFor(pauseDelay);
        }
        tw.start();
      }}
    />
  );
}
